"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var idm_workflow_service_client_js_1 = require("@synisys/idm-workflow-service-client-js");
var operators_1 = require("rxjs/operators");
var core_1 = require("@angular/core");
var overdue_warning_service_1 = require("../../../shared/services/api/overdue-warning.service");
var pending_action_settings_service_1 = require("../../../shared/services/api/pending-action-settings.service");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var type_configuration_service_1 = require("../../../shared/services/api/type-configuration.service");
var base_portfolio_helper_service_1 = require("../../summary-pages/common/service/base-portfolio-helper.service");
var pending_item_type_1 = require("../model/pending-item-type");
var idm_portfolio_control_1 = require("@synisys/idm-portfolio-control");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var of_1 = require("rxjs/observable/of");
var fromPromise_1 = require("rxjs/observable/fromPromise");
var root_category_summary_page_config_service_1 = require("../../../shared/services/api/summary-pages/root-category-summary-page-config-service");
var root_category_provider_service_1 = require("../../../shared/services/api/root-category-provider.service");
var portfolio_definition_custom_values_service_1 = require("../../../shared/services/api/portfolio-definition-custom-values.service");
var zip_1 = require("rxjs/observable/zip");
var portfolio_definitions_service_1 = require("../../../shared/services/api/portfolio-definitions.service");
var PendingActionPortfolioHelperService = /** @class */ (function () {
    function PendingActionPortfolioHelperService(kbService, processService, overdueWarningService, pendingActionSettingsService, rootCategorySummaryPageConfigService, rootCategoryProviderService, typeConfigurationService, basePortfolioHelperService, portfolioDefinitionsService, portfolioDefinitionCustomValuesService) {
        this.kbService = kbService;
        this.processService = processService;
        this.overdueWarningService = overdueWarningService;
        this.pendingActionSettingsService = pendingActionSettingsService;
        this.rootCategorySummaryPageConfigService = rootCategorySummaryPageConfigService;
        this.rootCategoryProviderService = rootCategoryProviderService;
        this.typeConfigurationService = typeConfigurationService;
        this.basePortfolioHelperService = basePortfolioHelperService;
        this.portfolioDefinitionsService = portfolioDefinitionsService;
        this.portfolioDefinitionCustomValuesService = portfolioDefinitionCustomValuesService;
    }
    PendingActionPortfolioHelperService.prototype.constructPendingPortfolio = function (pendingItemType, pendingActionSettings) {
        var _this = this;
        return zip_1.zip(this.constructPortfolioFilter(pendingItemType, pendingActionSettings), this.rootCategoryProviderService.getRootCategoryId(pendingActionSettings.itemCategoryName)).pipe(operators_1.switchMap(function (_a) {
            var defaultFilter = _a[0], rootCategoryId = _a[1];
            var portfolioConfigs$;
            if (!pendingActionSettings.portfolioId) {
                portfolioConfigs$ = _this.rootCategorySummaryPageConfigService.getPortfolioConfigByCategory(pendingActionSettings.itemCategoryName, rootCategoryId);
            }
            else {
                portfolioConfigs$ = _this.portfolioDefinitionsService.loadPortfolioDefinitionById(pendingActionSettings.portfolioId, pendingActionSettings.itemCategoryName);
            }
            return portfolioConfigs$.pipe(operators_1.switchMap(function (configs) {
                return _this.basePortfolioHelperService.constructBasePortfolio(configs, pendingActionSettings.itemCategoryName, rootCategoryId, defaultFilter);
            }));
        }));
    };
    PendingActionPortfolioHelperService.prototype.constructPortfolioFilter = function (pendingItemType, pendingActionItem) {
        var _this = this;
        var pendingActionFilter$ = of_1.of(null);
        var metaCategory;
        var wfStateFieldSystemName;
        var loadMetaCategory$ = this.kbService.getMetaCategoryByMetaCategoryId(new idm_kb_service_client_js_1.MetaCategoryId(pendingActionItem.itemCategoryName));
        var loadWFStateMetaField$ = this.kbService.getWorkflowStateMetaField(pendingActionItem.itemCategoryName);
        return zip_1.zip(loadMetaCategory$, loadWFStateMetaField$)
            .pipe(operators_1.switchMap(function (_a) {
            var category = _a[0], wfStateMetaField = _a[1];
            metaCategory = category;
            wfStateFieldSystemName = wfStateMetaField.getSystemName();
            return fromPromise_1.fromPromise(_this.processService.getStructure(metaCategory.getWFProcessId()));
        }), operators_1.switchMap(function (processStructure) {
            var finalStateIds = processStructure.getStates()
                .filter(function (state) { return state.getIsFinal(); })
                .map(function (state) { return state.getId(); });
            var filterBuilder = new idm_de_core_frontend_1.FilterBuilder();
            if (finalStateIds && finalStateIds.length) {
                filterBuilder.and(new idm_de_core_frontend_1.FilterBuilder().not(new idm_de_core_frontend_1.FilterBuilder().in(wfStateFieldSystemName, finalStateIds).build()).build());
            }
            if (pendingItemType === pending_item_type_1.PendingItemType.OVERDUE) {
                pendingActionFilter$ = _this.constructOverdueFilter(filterBuilder, pendingActionItem);
            }
            else if (pendingItemType === pending_item_type_1.PendingItemType.DRAFT) {
                filterBuilder = new idm_de_core_frontend_1.FilterBuilder().is(wfStateFieldSystemName, processStructure.getInitialStateId());
                pendingActionFilter$ = of_1.of(filterBuilder);
            }
            else if (pendingItemType === pending_item_type_1.PendingItemType.PENDING_REACTION) {
                filterBuilder.and(new idm_de_core_frontend_1.FilterBuilder().not(new idm_de_core_frontend_1.FilterBuilder().is(wfStateFieldSystemName, processStructure.getInitialStateId()).build()).build());
                pendingActionFilter$ = of_1.of(filterBuilder);
            }
            else if (finalStateIds && finalStateIds.length) {
                pendingActionFilter$ = of_1.of(filterBuilder);
            }
            return pendingActionFilter$.pipe(operators_1.map(function (resultFilterBuilder) {
                return new idm_portfolio_control_1.PortfolioFilterDto(_this.setDefaultFilter(resultFilterBuilder, pendingActionItem), null);
            }));
        }));
    };
    PendingActionPortfolioHelperService.prototype.constructOverdueFilter = function (filterBuilder, pendingActionItem) {
        var _this = this;
        return this.kbService.getInstanceMetaField(pendingActionItem.itemCategoryName)
            .pipe(operators_1.switchMap(function (instanceField) {
            return _this.overdueWarningService.getOverdueEntities(pendingActionItem.itemCategoryName)
                .pipe(operators_1.map(function (itemIds) {
                return filterBuilder.and(new idm_de_core_frontend_1.FilterBuilder().in(instanceField.getSystemName(), itemIds).build());
            }));
        }));
    };
    PendingActionPortfolioHelperService.prototype.setDefaultFilter = function (pendingActionFilterBuilder, pendingActionItem) {
        // If it has default filter - append it to filtering by item type
        var pendingActionFilter;
        if (pendingActionItem.defaultFilterJson) {
            if (pendingActionFilterBuilder) {
                var pendingActionFilterJson_1 = pendingActionFilterBuilder.build().toJson();
                pendingActionFilter = {
                    toJson: function () {
                        return { '$and': [pendingActionFilterJson_1, pendingActionItem.defaultFilterJson] };
                    }
                };
            }
            else {
                pendingActionFilter = {
                    toJson: function () {
                        return pendingActionItem.defaultFilterJson;
                    }
                };
            }
        }
        else if (pendingActionFilterBuilder) {
            pendingActionFilter = pendingActionFilterBuilder.build();
        }
        return pendingActionFilter;
    };
    PendingActionPortfolioHelperService = __decorate([
        core_1.Injectable(),
        __param(9, core_1.Optional()),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.KbService,
            idm_workflow_service_client_js_1.ProcessService,
            overdue_warning_service_1.OverdueWarningService,
            pending_action_settings_service_1.PendingActionSettingsService,
            root_category_summary_page_config_service_1.RootCategorySummaryPageConfigService,
            root_category_provider_service_1.RootCategoryProviderService,
            type_configuration_service_1.TypeConfigurationService,
            base_portfolio_helper_service_1.BasePortfolioHelperService,
            portfolio_definitions_service_1.PortfolioDefinitionsService,
            portfolio_definition_custom_values_service_1.PortfolioDefinitionCustomValuesService])
    ], PendingActionPortfolioHelperService);
    return PendingActionPortfolioHelperService;
}());
exports.PendingActionPortfolioHelperService = PendingActionPortfolioHelperService;
//# sourceMappingURL=pending-action-portfolio-helper.service.js.map